module.exports = __webpack_public_path__ + "d1e59e41140f0a7c9f730266e9bc508c.png";